var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block-head-line f-b-c"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),(!_vm.hidMoreBtn)?_c('a',{staticClass:"a-btn",attrs:{"href":_vm.moreBtnUrl,"target":"_blank"}},[_vm._v("更多 >")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }